// extracted by mini-css-extract-plugin
export var profile_content = "ProfileContent-module--profile_content--XB1rQ";